import {Component, OnInit} from '@angular/core';
import {Storage} from '@ionic/storage';
import AnalyticsService from '../../../services/analytics.service';
import {Router} from '@angular/router';
import {ViewDidEnter} from '@ionic/angular';

@Component({
    selector: 'app-cookies',
    templateUrl: './cookies.page.html',
    styleUrls: ['./cookies.page.css'],
})
export class CookiesPage implements ViewDidEnter {

    private isSaving = false;

    allowAnalytics = true;
    public analyticsText = 'Nutzungsdaten senden, damit die App verbessert werden kann. Es werden Google Analytics for Firebase und Firebase Crashlytics als Dienste verwendet.';

    constructor(private storage: Storage, private analytics: AnalyticsService, private router: Router) {
    }

    async ionViewDidEnter() {
        const analyticsText = await this.storage.get('analyticsText');
        if (!!analyticsText) {
            this.allowAnalytics = await this.storage.get('analytics');
        }
    }

    toggleAnalytics(ev) {
        this.allowAnalytics = ev.detail.checked;
    }

    async save() {
        if (this.isSaving) {
            return;
        }

        this.isSaving = true;

        console.log('Save analytics', this.allowAnalytics);

        await this.storage.set('analytics', this.allowAnalytics);
        await this.storage.set('analyticsText', this.analyticsText);

        this.analytics.toggleAnalytics(this.allowAnalytics);

        this.isSaving = false;

        this.router.navigate(['/home'], {
            replaceUrl: true
        });
    }
}
